<template>
	<div class="wrapper">
		<headerTag />
		<div class="twDiv twDiv2">
			<p>
				<img src="../../assets/images/user/wt_user.png" class="tsUser_img" />
				<span>{{describe}}</span>
			</p>
			<p class="wtTime">
				<span>{{createDate}}</span>&nbsp;&nbsp;提交
			</p>
			<p class="wtTags">
				<span>{{typeName}}</span>
			</p>
		</div>
		<div class="twDiv twDiv3">
			<p>{{status}}</p>
			<p>{{answer}}</p>
		</div>
		<footerTag />
	</div>

</template>

<script>
   
    import "../../assets/css/user.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    import footerTag from '@/components/footerTag/footerTag.vue'
    
    export default {
    	name: 'wenDetail',
    	props: {
        
    	},
    	data(){
		  return {
		    aid:'',
		    describe:'',
		    createDate:'',
		    status:'',
		    answer:'',
		    typeName:''
		  }
		},
    	components: {
    		headerTag,
    		footerTag
    	},
    	methods: {
				loadAskDetail(){
					this.axios({
					 	method: 'POST',
					 	url:'/feedback/getAskDetail',
						params:{
							aid:this.aid
					 	},
					}).then((res)=>{
							if(res.data.code==1000){
					 			let data = res.data.obj;
					 			this.describe=data.describe;
					 			this.createDate=data.createDate;
					 			this.status=data.status;
								this.answer=data.answer;
								this.typeName=data.typeName;
					 		}else if(res.data.code == 1110){
				  				//未登录
				  				let currPath=window.location.href;
				  				window.location.href='/login?targetUrl='+currPath;
				  			}else{
				  				this.$message.error({message: '网络异常，请稍后重试'});
				  			}
					}).catch((err)=>{
					 	this.$message.error({message: '获取数据失败'});
					})
				},
		},
    	created(){
			this.aid = this.$route.params.id;
			this.loadAskDetail();
		}
    }
</script>